import type { Infer } from 'superstruct';
import { boolean, object, optional } from 'superstruct';

import { email, userString } from '@adflow/shared/util-superstruct';

export const DUPLICATE_USER_EMAIL = 'validations:Duplicate User Email';

export const AddUserDto = object({
	name: userString('validations:Required'),
	email: email(),
	superuser: optional(boolean()),
	archived: optional(boolean()),
	sendWelcomeEmail: optional(boolean()),
});

export type AddUserDto = Infer<typeof AddUserDto>;
